import React, { useEffect, useState } from 'react';
import Body from 'ui/Typography/Body';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import SkapaCheckbox from 'ui/Checkbox/SkapaCheckbox';
import media from 'ui/media';
import PlainList from 'ui/PlainList/PlainList';
import ListItem from 'ui/PlainList/ListItem';

const SizeFilterGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  ${space}
  ${media.mobile`  
    margin-bottom: 1rem; 
  `}
`;

type SizeOptions = {
  [value: string]: string;
};

type SizeFilterProps = SpaceProps & {
  sizes: SizeOptions;
  label: string;
  onFilter: (size: number) => void;
  filterState: any;
  name: string;
  id: string;
  disabledSizes?: string[];
};

type FormattedSize = {
  value: number;
  text: string;
  disabled?: boolean;
};

const SizeFilter = ({
  id,
  sizes,
  label,
  name,
  onFilter,
  filterState,
  disabledSizes,
  ...props
}: SizeFilterProps) => {
  const [formatedSizes, setFormatedSize] = useState<FormattedSize[]>([]);
  useEffect(() => {
    const newFormatedSizes = Object.entries(sizes).map(([size, communicated]) => {
      return {
        value: parseInt(size, 10),
        text: communicated,
        disabled: disabledSizes?.includes(size)
      };
    });
    setFormatedSize(newFormatedSizes);
  }, [sizes, disabledSizes]);

  return (
    <SizeFilterGroup {...props}>
      <Body
        id={name}
        mr="s"
        type={ThemeFontStyleTypeEnum.bodyMedium}
        style={{ minWidth: '90px' }}
        mb="1rem"
      >
        {label}
      </Body>
      <PlainList
        ariaLabelledBy={name}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          listStyleType: 'none',
          margin: '0',
          padding: '0'
        }}
      >
        {formatedSizes.map(({ value, text, disabled }) => {
          const dataAndLabelId = `${id}-${value / 10}`;
          return (
            <ListItem
              key={dataAndLabelId}
              data-disabled={disabled}
              data-testid={dataAndLabelId}
              style={{ marginBottom: formatedSizes.length > 4 ? '1rem' : '0', marginRight: '1rem' }}
            >
              <SkapaCheckbox
                id={dataAndLabelId}
                label={text}
                value={value.toString()}
                disabled={disabled}
                checked={!!filterState[value]}
                onChange={() => onFilter(value)}
                name={name}
              />
            </ListItem>
          );
        })}
      </PlainList>
    </SizeFilterGroup>
  );
};

export default SizeFilter;
